import { Box, useTheme } from '@mui/material'

import StateIcon from 'components/global/StateIcon'

const DropdownIndicator = ({ ...props }) => {
  const theme = useTheme();
  return (
    <Box mr={1}>
      {props.selectProps.menuIsOpen ? (
        <StateIcon
          iconlabel={'angle-up'}
          iconweight={'regular'}
          iconcolor={theme.palette.primary.main}
        />
      ) : (
        <StateIcon iconweight={'regular'} iconlabel={'angle-down'} />
      )}
    </Box>
  );
};

export default DropdownIndicator
